import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const client = axios.create({ baseURL: API, timeout: 15000 });

export const api = {
  config: () => client.get("/config").then((r) => r.data),
  price: () => client.get("/price").then((r) => r.data),
  priceHistory: () => client.get("/price/history").then((r) => r.data),
  connect: (address, sponsor_code) =>
    client.post("/user/connect", { address, sponsor_code }).then((r) => r.data),
  user: (address) => client.get(`/user/${address}`).then((r) => r.data),
  rewards: (address) => client.get(`/user/${address}/rewards`).then((r) => r.data),
  rewardsAll: (address) => client.get(`/user/${address}/rewards`, { params: { limit: 2000 } }).then((r) => r.data),
  stake: (payload) => client.post("/stake", payload).then((r) => r.data),
  authChallenge: (address, action) => client.post("/auth/wallet-challenge", { address, action }).then((r) => r.data),
  claim: (address) => client.post(`/user/${address}/claim`).then((r) => r.data),
  claimPrincipal: (address, stake_id) => client.post(`/user/${address}/claim-principal`, { stake_id }).then((r) => r.data),
  referrals: (address) => client.get(`/user/${address}/referrals`).then((r) => r.data),
  shares: (address) => client.get(`/user/${address}/shares`).then((r) => r.data),
  pools: () => client.get("/pools").then((r) => r.data),
  predictionCurrent: (address) =>
    client.get("/prediction/current", { params: { address } }).then((r) => r.data),
  predictionBet: (payload) => client.post("/prediction/bet", payload).then((r) => r.data),
  predictionHistory: () => client.get("/prediction/history").then((r) => r.data),
  withdraw: (payload) => client.post("/withdraw", payload).then((r) => r.data),
  withdrawPrincipal: (address, sig) => client.post(`/user/${address}/withdraw-principal`, sig).then((r) => r.data),
  metrics: () => client.get("/dashboard/metrics").then((r) => r.data),
  contracts: () => client.get("/contracts").then((r) => r.data),
  adminConfig: () => client.get("/admin/config").then((r) => r.data),
  adminChallenge: (address) => client.post("/admin/challenge", { address }).then((r) => r.data),
  adminVerify: (payload) => client.post("/admin/verify", payload).then((r) => r.data),
  adminOverview: (token) =>
    client.get("/admin/overview", { headers: { Authorization: `Bearer ${token}` } }).then((r) => r.data),
  adminMembers: (params, token) =>
    client.get("/admin/members", { params, headers: { Authorization: `Bearer ${token}` } }).then((r) => r.data),
  adminMemberDetail: (address, token) =>
    client.get(`/admin/member/${address}`, { headers: { Authorization: `Bearer ${token}` } }).then((r) => r.data),
  adminReactivateMember: (address, token) =>
    client.post(`/admin/member/${address}/reactivate`, {}, { headers: { Authorization: `Bearer ${token}` } }).then((r) => r.data),
  adminSetRate: (rate_bps, token) =>
    client.post("/admin/daily-rate", { rate_bps }, { headers: { Authorization: `Bearer ${token}` } }).then((r) => r.data),
  adminTopup: (amount, token) =>
    client.post("/admin/revenue-topup", { amount }, { headers: { Authorization: `Bearer ${token}` } }).then((r) => r.data),
  adminTestSpeed: (enabled, minutes, token) =>
    client.post("/admin/test-speed", { enabled, minutes }, { headers: { Authorization: `Bearer ${token}` } }).then((r) => r.data),
  adminWinners: (pool, winners, token) =>
    client.post("/admin/pool-winners", { pool, winners }, { headers: { Authorization: `Bearer ${token}` } }).then((r) => r.data),
  chainStatus: () => client.get("/chain/status").then((r) => r.data),
  chainEvents: (params) => client.get("/chain/events", { params }).then((r) => r.data),
  chainLeaderboard: (limit) => client.get("/chain/leaderboard", { params: { limit } }).then((r) => r.data),
  chainReserves: () => client.get("/chain/reserves").then((r) => r.data),
  chainUser: (address) => client.get(`/chain/user/${address}`).then((r) => r.data),
  chainDirects: (address) => client.get(`/chain/directs/${address}`).then((r) => r.data),
  exchangeInfo: () => client.get("/exchange/info").then((r) => r.data),
  exchangeQuote: (side, amount) => client.get("/exchange/quote", { params: { side, amount } }).then((r) => r.data),
  predictionSchedule: (address, tier) => client.get("/prediction/schedule", { params: { address, tier } }).then((r) => r.data),
  predictionPackages: (address) => client.get("/prediction/packages", { params: { address } }).then((r) => r.data),
  predictionAnswer: (payload) => client.post("/prediction/answer", payload).then((r) => r.data),
  predictionResolved: (address) => client.get("/prediction/resolved", { params: { address } }).then((r) => r.data),
  adminChainStatus: (token) =>
    client.get("/admin/chain/status", { headers: { Authorization: `Bearer ${token}` } }).then((r) => r.data),
  adminDistributePool: (pool, token) =>
    client.post("/admin/chain/distribute-pool", { pool }, { headers: { Authorization: `Bearer ${token}` } }).then((r) => r.data),
  adminLevelPayout: (payload, token) =>
    client.post("/admin/chain/level-payout", payload, { headers: { Authorization: `Bearer ${token}` } }).then((r) => r.data),
  adminLevelConfig: (payload, token) =>
    client.post("/admin/chain/level-config", payload, { headers: { Authorization: `Bearer ${token}` } }).then((r) => r.data),
  mktUser: (address) => client.get(`/mkt/user/${address}`).then((r) => r.data),
  userRewards: (address) => client.get(`/user/${address}/rewards`).then((r) => r.data),
  mktFeed: () => client.get("/mkt/feed").then((r) => r.data),
  mktWithdraw: (payload) => client.post("/mkt/withdraw", payload).then((r) => r.data),
  adminMktStatus: (token) =>
    client.get("/admin/mkt/status", { headers: { Authorization: `Bearer ${token}` } }).then((r) => r.data),
  adminMktGrant: (payload, token) =>
    client.post("/admin/mkt/grant", payload, { headers: { Authorization: `Bearer ${token}` } }).then((r) => r.data),
  adminMktBudget: (payload, token) =>
    client.post("/admin/mkt/budget", payload, { headers: { Authorization: `Bearer ${token}` } }).then((r) => r.data),
  adminMktToggle: (payload, token) =>
    client.post("/admin/mkt/toggle", payload, { headers: { Authorization: `Bearer ${token}` } }).then((r) => r.data),
  adminMktSettle: (payload, token) =>
    client.post("/admin/mkt/settle", payload, { headers: { Authorization: `Bearer ${token}` } }).then((r) => r.data),
};

export default api;
